<template>
  <div>
    <h1>Optional Insurance</h1>

    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          @change="updateOptionalInsuranceField"
          name="opts"
          value="5"
          :checked="optionalInsurance.opts.includes('5')"
        >
        Watercraft Liability
      </label>
    </div>

    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          name="opts"
          value="3"
          @change="updateOptionalInsuranceField"
          :checked="optionalInsurance.opts.includes('3')"
        >
        Uninsured Motorist Plus
      </label>
    </div>

    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          value="6"
          name="opts"
          @change="updateOptionalInsuranceField"
          :checked="optionalInsurance.opts.includes('6')"
        >
        Business Use
      </label>
    </div>

    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          name="opts"
          value="4"
          :disabled="!isFullCoverage"
          @change="updateOptionalInsuranceField"
          :checked="optionalInsurance.opts.includes('4')"
        >
        VIP Endorsement
      </label>
    </div>

    <h5>Additional Liability</h5>
    <div class="additional-liability-options">
      <div class="radio">
        <label>
          <input
            type="radio"
            value=""
            name="addLiability"
            @change="updateOptionalInsuranceField"
            :checked="optionalInsurance.addLiability==''"
          >
          No Additional Liability
        </label>
      </div>

      <div class="radio">
        <label>
          <input
            type="radio"
            value="1"
            name="addLiability"
            @change="updateOptionalInsuranceField"
            :checked="optionalInsurance.addLiability=='1'"
          >
          $750,000 Liability
        </label>
      </div>

      <div class="radio">
        <label>
          <input
            type="radio"
            value="7"
            name="addLiability"
            @change="updateOptionalInsuranceField"
            :checked="optionalInsurance.addLiability=='7'"
          >
          $1,000,000 Liability
        </label>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';

export default {
  name: 'OptionalInsurancePolicyPart',
  props: [],
  computed: {
    ...mapState([
      'optionalInsurance',
    ]),
    ...mapGetters([
      'isFullCoverage',
    ]),
  },
  methods: {
    ...mapActions([
      'updateOptionalInsurance',
    ]),
    updateOptionalInsuranceField(e) {
      const payload = {
        field: e.target.name,
        value: e.target.value,
        checked: e.target.checked,
      }
      this.updateOptionalInsurance(payload)
    },
  },
}
</script>

<style>
.additional-liability-options {
  display: flex;
}
.additional-liability-options .radio {
  margin-top: 0px;
}
</style>
